/*
 * @Author: your name
 * @Date: 2022-01-07 09:17:01
 * @LastEditTime: 2021-05-12 11:29:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/business/rebates/api.js
 */
import request from '@/router/axios';
/**
 * 博主付款相关接口
 */
// 博主付款申请，确认调整
export function bloggerPayConfirm(obj) {
  return request({
    url: '/api/paymentBatch/updateTrans' ,
    method: 'put',
    data: obj
  })
}


//博主付款获取列表
export function listBloggerPayInfo(query) {
  return request({
    url: '/api/paymentBatch/pageList/1',
    method: 'get',
    params: query
  })
}


// 博主付款申请，提交付款申请
export function submitBloggerPayInfo(obj) {
  return request({
    url: '/api/paymentBatch/bloggerPaySubmit' ,
    method: 'put',
    data: obj
  })
}


/**
 * 代下单付款相关接口
 */
// 代下单付款申请，确认调整
export function orderPayConfirm(obj) {
  return request({
    url: '/api/paymentBatch/updateOrderPrice' ,
    method: 'put',
    data: obj
  })
}


//代下单付款获取列表
export function listOrderPayInfo(query) {
  return request({
    url: '/api/paymentBatch/pageList/2',
    method: 'get',
    params: query
  })
}


// 代下单付款申请，提交付款申请
export function submitOrderPayInfo(obj) {
  return request({
    url: '/api/paymentBatch/bloggerPaySubmit' ,
    method: 'put',
    data: obj
  })
}



/**
 * 返点付款相关接口
 */
// 返点付款申请，确认调整
export function pointPayConfirm(obj) {
  return request({
    url: '/api/paymentBatch/updateRebatePrice' ,
    method: 'put',
    data: obj
  })
}


//返点付款获取列表
export function listPointPayInfo(query) {
  return request({
    url: '/api/paymentBatch/pageList/3',
    method: 'get',
    params: query
  })
}


// 返点付款申请，提交付款申请
export function submitPointPayInfo(obj) {
  return request({
    url: '/api/paymentBatch/bloggerPaySubmit' ,
    method: 'put',
    data: obj
  })
}


/**
 * 其他付款相关接口
 */
// 其他付款申请，确认调整
export function otherPayConfirm(obj) {
  return request({
    url: '/api/paymentBatch/updateOtherPrice' ,
    method: 'put',
    data: obj
  })
}


//其他付款获取列表
export function listOtherPayInfo(query) {
  return request({
    url: '/api/paymentBatch/pageList/4',
    method: 'get',
    params: query
  })
}


// 其他付款申请，提交付款申请
export function submitOtherPayInfo(obj) {
  return request({
    url: '/api/paymentBatch/bloggerPaySubmit' ,
    method: 'put',
    data: obj
  })
}



//供应商列表
export function supplierBusinessList(query) {
  return request({
    url: '/api/supplier/payment/page',
    method: 'get',
    params: query
  })
}


//投放导出
export function exportBloggerPayInfo(query) {
  return request({
    url: '/api/paymentBatch/export',
    method: 'get',
    params: query,
    responseType: 'blob',
  })
}

//批量导入返点 
export function recordPointImport(query) {
  return request({
    url:'/api/paymentBatch/importPoint',
    method: 'post',
    headers: {
        "Content-Type": "multipart/form-data"
    },
    data: query
  })
}

//批量导入代下单金额
export function recordOrderImport(query) {
  return request({
    url:'/api/paymentBatch/importOrder',
    method: 'post',
    headers: {
        "Content-Type": "multipart/form-data"
    },
    data: query
  })
}

//批量导入其他费用
export function recordOtherImport(query) {
  return request({
    url:'/api/paymentBatch/importOther',
    method: 'post',
    headers: {
        "Content-Type": "multipart/form-data"
    },
    data: query
  })
}


//博主付款，获取对应博主收款账号信息
export function getPayerInfo(query) {
  return request({
    url: '/api/paymentBatch/payerInfo',
    method: 'get',
    params: query
  })
}

//返点付款，获取对应合同中甲方客户付款信息
export function getCustomerPayerInfo(query) {
  return request({
    url: '/api/paymentBatch/customerPayerInfo',
    method: 'get',
    params: query
  })
}


// 加入购物车
export function addShopcar(obj) {
  return request({
    url: '/api/paymentBatch/addShopcar' ,
    method: 'put',
    data: obj
  })
}

// 删除购物车
export function subShopcar(obj) {
  return request({
    url: '/api/paymentBatch/subShopcar' ,
    method: 'put',
    data: obj
  })
}


//博主付款购物车
export function getShopcarList(query) {
  return request({
    url: '/api/paymentBatch/getShopcarList/1',
    method: 'get',
    params: query
  })
}


//代下单付款购物车
export function getOrderShopcarList(query) {
  return request({
    url: '/api/paymentBatch/getShopcarList/2',
    method: 'get',
    params: query
  })
}


//返点付款购物车
export function getPointShopcarList(query) {
  return request({
    url: '/api/paymentBatch/getShopcarList/3',
    method: 'get',
    params: query
  })
}


//其他付款购物车
export function getOtherShopcarList(query) {
  return request({
    url: '/api/paymentBatch/getShopcarList/4',
    method: 'get',
    params: query
  })
}


// 批次审批失败，一键加入购物车
export function addBatchShopcar(obj) {
  return request({
    url: '/api/paymentBatch/addBatchShopcar' ,
    method: 'put',
    data: obj
  })
}


